'use client';

import { c as _c } from "react/compiler-runtime";
import { useSuspenseQuery } from '@tanstack/react-query';
import { AuthQueryOptions } from '@/api';
import { parseKstDateToMs } from '../../_utils/countdown';
export interface BonusSlotData {
  /** 서버가 내려주는 다음 수령 가능 시각 epoch ms. 지금 받을 수 있으면 null */
  nextAvailableAtMs: number | null;
}
export const useBonusSlot = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...AuthQueryOptions["get:/wello/v2/auth/benefit-tickets/lucky-ticket"](),
      select: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useSuspenseQuery(t0);
};
function _temp(response) {
  return {
    nextAvailableAtMs: response.context?.nextAvailableAt ? parseKstDateToMs(response.context.nextAvailableAt) : null
  };
}